import React, { Fragment, useEffect, useState } from 'react';
import ReportTile from '../components/ReportTile';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/logo.png';
import logo_text from '../assets/logo_text.png';
import { supabase } from '../supabase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Drawer } from '@mui/material';
import AddReport from '../components/AddReport';
import { Modal } from 'react-bootstrap';

export default function Dashboard() {

    // get local storage
    let session = localStorage.getItem("sb-wtlkhsfpanurgzhaiocq-auth-token");
    if (session) {
        session = JSON.parse(session);
    }
    
    const storageURL = "https://wtlkhsfpanurgzhaiocq.supabase.co/storage/v1/object/public/reports";
    const items = ["Reports", "Billing"];
    const [activeItem, setActiveItem] = useState("Reports");
    const [reports, setReports] = useState([]);
    const [openAddReportModal, setOpenAddReportModal] = useState(false);
    const [openDeleteReportModal, setOpenDeleteReportModal] = useState(false);
    const [deleteReportId, setDeleteReportId] = useState(null);

    // determine if mobile
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = width <= 768;

    useEffect(() => {
        const getReports = async () => {
            // get folder and report titles from supabase
            try {
                const { data, error, status } = await supabase
                    .from("Profile")
                    .select("reports")
                    .eq('id', session.user.id);

                if (error && status !== 406) {
                    throw error
                }
                if (data) {
                    let reports = data[0].reports;
                    let newReports = [];
                    reports.forEach(report => {
                        newReports.push({
                            "id": report.id,
                            "title": report.title,
                            "logo": logo,
                            "overallPosition": report.overallPosition,
                            "numCodes": report.numCodes,
                            "clientBillingCode": report.clientBillingCodes,
                            "clientRate": report.clientRate,
                            "compareBillingCodes": report.compareBillingCodes,
                            "expectedNegotiation": report.expectedNegotiation,
                            "URL": `${storageURL}/${session.user.id}/${report.title}`,
                            "generated": false
                        })
                    })
                    setReports(newReports);
                }
            } catch (error) {
                console.error(error.message);
            }
        }
        
        getReports()
    // eslint-disable-next-line
    }, [])

    const infoMsg = (msg) => toast.info(<p>{msg}</p>, {
        toastId: 'infoMsg',
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
    });

    const handleSetItem = (item) => {
        setActiveItem(item);
        if (item === "Home") {
            let newURL = null
            if (window.location.href.includes("localhost:3000")) {
                newURL = `http://localhost:3000/dashboard`;
            } else {
                newURL = `http://eggshelliq.com/dashboard`;
            }
            window.history.pushState('page2', 'Title', newURL);
        } else {
            let newURL = null
            if (window.location.href.includes("localhost:3000")) {
                newURL = `http://localhost:3000/dashboard?view_${item.toLowerCase()}=true`;
            } else {
                newURL = `http://eggshelliq.com/dashboard?view_${item.toLowerCase()}=true`;
            }
            window.history.pushState('page2', 'Title', newURL);
        }
    }

    // drawer for mobile
    const [drawer, setDrawer] = useState({
        left: false
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawer({ ...drawer, [anchor]: open });
    };
    
    const handleDeleteReport = async () => {
        let newReports = [];
        reports.forEach(tempReport => {
            if (tempReport.id !== deleteReportId) {
                newReports.push(tempReport);
            }
        })
        setReports(newReports);

        // save to supabase
        try {
            const updates = {
                id: session.user.id,
                reports: reports
            }

            let { error } = await supabase.from('Profile').upsert(updates).select()
            
            if (error) {
                throw error
            } else {
                setOpenDeleteReportModal(false);
                infoMsg('Report deleted successfully');
            }
            
        } catch (error) {
            console.error(error.message)
        }
    }

    return (
        <>
            <div className={`lg:flex lg:justify-start lg:gap-10 ${isMobile ? '-mt-20 mx-2' : 'mt-3 mx-5'}`}>
                
                {/* Add report modal */}
                <Modal size={'lg'} centered={true} show={openAddReportModal} onHide={() => setOpenAddReportModal(false)}>
                    <Modal.Body className={`${isMobile ? 'mx-2' : 'mx-8'} mt-1 mb-4`}>
                        <div className="flex justify-between">
                            <img src={logo_text} alt="logo" className='h-7 mt-2' />
                            {/* Close modal */}
                            <FontAwesomeIcon
                                icon={faXmark}
                                onClick={() => setOpenAddReportModal(false)}
                                style={{ paddingLeft: '14px', paddingRight: '14px' }}
                                className='text-xl py-2.5 -mt-1 -mr-5 cursor-pointer hover:rounded-full hover:bg-light-gray-2'
                            />
                        </div>
                        <AddReport
                            session={session}
                            reports={reports}
                            setReports={setReports}
                            storageURL={storageURL}
                        />
                    </Modal.Body>
                </Modal>
                
                {/* Delete modal */}
                <Modal size={'md'} centered={true} show={openDeleteReportModal} onHide={() => setOpenDeleteReportModal(false)}>
                    <Modal.Body className={`${isMobile ? 'mx-2' : 'mx-8'} mt-1 mb-4`}>
                        <div className="flex justify-between">
                            <img src={logo_text} alt="logo" className='h-7 mt-2' />
                            {/* Close modal */}
                            <FontAwesomeIcon
                                icon={faXmark}
                                onClick={() => setOpenDeleteReportModal(false)}
                                style={{ paddingLeft: '14px', paddingRight: '14px' }}
                                className='text-xl py-2.5 -mt-1 -mr-5 cursor-pointer hover:rounded-full hover:bg-light-gray-2'
                            />
                        </div>
                        <div className='mx-2'>
                            <p className='text-3xl text-center font-extrabold tracking-tight mt-4'>Confirm deletion</p>
                            <p className='text-xl font-semibold mt-6 mx-2'>Are you sure you want to delete report this report?</p>
                            <button
                                onClick={() => handleDeleteReport()}
                                className='mt-4 w-100 h-12 rounded-xl text-xl text-white bg-red'
                            >
                                Yes, delete
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
                
                {isMobile ? (
                    <div className='hidden'></div>
                ) : (
                    <div className='bg-light-gray-2 text-white w-80 rounded-xl p-4' style={{height: '88vh'}}>
                        <div className='flex justify-center items-center'>
                            <p className='text-left text-black text-xl py-2.5'>Eggshell IQ Dashboard</p>
                        </div>
                        {items.map(function (item, index) {
                            return (
                                <div className='flex flex-col justify-start items-center gap-5 mt-3 text-black text-lg font-semibold'>
                                    <div
                                        onClick={() => handleSetItem(item)}
                                        className={`flex justify-between items-center w-72 px-2.5 cursor-pointer py-2.5 hover:bg-light-gray-3 rounded-md ${item === activeItem ? 'bg-light-gray-3': 'bg-light-gray-2'}`}
                                    >
                                        <p>{item}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
                <div style={{height: '88vh'}}>
                    <div className={activeItem ==='Reports' ? 'text-black p-4' : 'hidden'}>
                        <div className='flex justify-between' style={{width: isMobile ? '100%' : '65vw'}}>
                            <div className='flex justify-start gap-2'>
                                <div className='lg:hidden'>
                                    <Fragment key={'left'}>
                                        <button
                                            onClick={toggleDrawer('left', true)}
                                            className='px-2.5 py-2.5 -mt-0.5 -ml-3 rounded-md bg-light-gray hover:bg-light-gray-2'
                                        >
                                            <FontAwesomeIcon icon={faArrowLeft} className="text-2xl text-gray" />
                                        </button>
                                        <Drawer
                                            anchor={'left'}
                                            open={drawer['left']}
                                            onClose={toggleDrawer('left', false)}
                                        >
                                            <div className='p-3 pt-5' onClick={toggleDrawer('left', false)}>
                                                <p className='text-center text-xl font-semibold'>Eggshell IQ Dashboard</p>
                                                <hr className='border-light-gray-3 mt-2' style={{borderWidth: '1px'}} />
                                                {items.map(function (item, index) {
                                                    return (
                                                        <div className='flex flex-col justify-start items-start gap-5 mt-3 text-black text-lg'>
                                                            <div
                                                                onClick={() => handleSetItem(item)}
                                                                style={{width: '100%'}}
                                                                className={`flex justify-between items-center px-2.5 cursor-pointer py-2.5 hover:bg-light-gray-3 rounded-md ${item === activeItem ? 'bg-light-gray-2': ''}`}
                                                            >
                                                                <p>{item}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Drawer>
                                    </Fragment>
                                </div>
                                <p className='text-3xl font-extrabold tracking-tight'>{isMobile ? 'Reports' : 'Reports Dashboard'}</p>
                            </div>
                            <button onClick={() => setOpenAddReportModal(true)} className='text-lg text-white px-4 py-1.5 rounded-xl bg-black hover:bg-[#252525]'>
                                <div className='flex justify-center items-center'>
                                    <FontAwesomeIcon icon={faPlus} className='mr-2' />
                                    <p className='mb-0.5'>Report</p>
                                </div>
                            </button>
                        </div>
                        <div
                            style={{height: isMobile ? '100%' : '100%'}}
                            className={`mt-16 lg:flex lg:justify-start lg:gap-10 ${isMobile ? '' : ''}`}
                        >
                            <div
                                style={{width: '100%'}}
                                className='flex justify-start gap-3 flex-wrap'
                            >
                                {reports.map(function (report, index) {
                                    return (
                                        <div className={isMobile ? 'mt-5' : ''}>
                                            <ReportTile
                                                report={report} 
                                                index={index}
                                                reports={reports}
                                                setReports={setReports}
                                                setOpenDeleteReportModal={setOpenDeleteReportModal}
                                                setDeleteReportId={setDeleteReportId}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={activeItem ==='Billing' ? 'text-black p-4' : 'hidden'}>
                        <div className='flex justify-start gap-2'>
                            <div className='lg:hidden'>
                                <Fragment key={'left'}>
                                    <button
                                        onClick={toggleDrawer('left', true)}
                                        className='px-2.5 py-2.5 -mt-0.5 -ml-3 rounded-md bg-light-gray hover:bg-light-gray-2'
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft} className="text-2xl text-gray" />
                                    </button>
                                    <Drawer
                                        anchor={'left'}
                                        open={drawer['left']}
                                        onClose={toggleDrawer('left', false)}
                                    >
                                        <div className='p-3 pt-5' onClick={toggleDrawer('left', false)}>
                                            <p className='text-center text-xl font-semibold'>Eggshell IQ Dashboard</p>
                                            <hr className='border-light-gray-3 mt-2' style={{borderWidth: '1px'}} />
                                            {items.map(function (item, index) {
                                                return (
                                                    <div className='flex flex-col justify-start items-start gap-5 mt-3 text-black text-lg'>
                                                        <div
                                                            onClick={() => handleSetItem(item)}
                                                            style={{width: '100%'}}
                                                            className={`flex justify-between items-center px-2.5 cursor-pointer py-2.5 hover:bg-light-gray-3 rounded-md ${item === activeItem ? 'bg-light-gray-2': ''}`}
                                                        >
                                                            <p>{item}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Drawer>
                                </Fragment>
                            </div>
                            <p className='text-3xl font-extrabold tracking-tight'>Go to Stripe dashboard</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
